import { GF_FieldError, GF_Survey } from '../../../model/gforms/gform';
import useGravityForm, { ACTION_TYPES } from '../../../hooks/GFormsHooks';
import { useEffect, useState } from 'react';
import { FieldDescription } from './subparts/FieldDescription';

interface Props {
  field: GF_Survey;
  fieldErrors: GF_FieldError[];
}

let defaultValue = '';

export default function SurveyField({ field, fieldErrors }: Props) {
  const {
    id,
    formId,
    type,
    label,
    description,
    cssClass,
    choices,
    visibility,
  } = field;
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  const ratingsInputs =
    choices?.map((choice, index) => ({ ...choice, id: index })) || [];
  const htmlId = `field_${formId}_${id}`;
  const { dispatch } = useGravityForm();

  useEffect(() => {
    choices?.map((choice, index) => {
      if (choice.isSelected && choice.value !== undefined) {
        defaultValue = choice.value;
        setRating(index);
        return defaultValue;
      }
      return defaultValue;
    });

    if (defaultValue !== '') {
      dispatch({
        type: ACTION_TYPES.updateRadioFieldValue,
        fieldValue: {
          id,
          value: defaultValue,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleChange(value) {
    dispatch({
      type: ACTION_TYPES.updateRadioFieldValue,
      fieldValue: {
        id,
        value: value,
      },
    });
  }

  return (
    <fieldset
      id={htmlId}
      className={`flex flex-wrap justify-between mt-4 md:mt-5 gfield gfield-${type} ${cssClass} ${
        visibility === 'hidden' ? 'hidden' : ''
      }`.trim()}
    >
      <div className="flex flex-col gap-3">
        <legend className="flex items-center text-black text-sm font-medium">
          {label}
        </legend>
        <FieldDescription description={description} />
      </div>
      <div className="flex items-center">
        {ratingsInputs.map(({ id, text, value, isSelected }) => (
          <div className="flex justify-between px-1" key={id}>
            <button
              type="button"
              key={id}
              onClick={() => {
                handleChange(value);
                setRating(id);
              }}
              onMouseEnter={() => setHover(id)}
              onMouseLeave={() => setHover(rating)}
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity={id <= (hover || rating) ? '1' : '0.3'}
                  d="M10.5619 1.3014C10.5955 1.21285 10.6556 1.13655 10.7341 1.0827C10.8127 1.02885 10.9059 1 11.0014 1C11.0969 1 11.1902 1.02885 11.2687 1.0827C11.3472 1.13655 11.4073 1.21285 11.4409 1.3014L13.8178 7.97685H20.5304C20.6264 7.97684 20.7201 8.00598 20.7989 8.06033C20.8776 8.11468 20.9377 8.19164 20.9709 8.28083C21.0042 8.37003 21.009 8.46718 20.9848 8.55919C20.9607 8.65121 20.9086 8.73367 20.8356 8.79547L15.2264 13.4021L17.5741 20.3882C17.6055 20.4818 17.6061 20.5829 17.5757 20.6768C17.5453 20.7708 17.4855 20.8527 17.405 20.9108C17.3246 20.9689 17.2275 21.0001 17.1279 21C17.0283 20.9999 16.9314 20.9684 16.851 20.9101L11.0005 16.6579L5.14708 20.9101C5.0667 20.9672 4.97013 20.9978 4.87118 20.9973C4.77222 20.9969 4.67594 20.9655 4.59607 20.9076C4.5162 20.8498 4.45683 20.7684 4.42643 20.6751C4.39603 20.5818 4.39616 20.4814 4.4268 20.3882L6.77454 13.4021L1.16438 8.79547C1.09143 8.73367 1.03935 8.65121 1.01516 8.55919C0.990965 8.46718 0.995824 8.37003 1.02908 8.28083C1.06233 8.19164 1.12239 8.11468 1.20115 8.06033C1.27991 8.00598 1.3736 7.97684 1.46958 7.97685H8.18318L10.5619 1.3014Z"
                  stroke={id <= (hover || rating) ? '#47D7AC' : '#000'}
                  fill={id <= (hover || rating) ? '#47D7AC' : ''}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        ))}
      </div>
      {fieldErrors?.length
        ? fieldErrors.map((fieldError) => (
            <p
              key={fieldError.id}
              className="error-message text-error font-medium text-sm mt-2"
            >
              {fieldError.message}
            </p>
          ))
        : null}
    </fieldset>
  );
}
